"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isIE() {
    var userAgent = window.navigator.userAgent;
    var isLegacyIE = userAgent.indexOf('MSIE') > 0;
    var isIE11 = userAgent.indexOf('Trident') > 0;
    // Calculate Result
    var result = (isLegacyIE || isIE11);
    // Log Result
    console.log("Rendering for IE: " + result);
    // Return
    return result;
}
exports.isIE = isIE;
//# sourceMappingURL=General.js.map